export default __webpack_public_path__ + "static/icons-sprite-6c0d961c70f26116c380e384ea7e1914.svg";